import React,{Component} from "react";
import  "./Dropdown.css";
import  dropdown from "../../../assets/images/dropdown_click.svg";
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc Custom Dropdown
 * @param props
 * @return Dom
 */

const DropdownPopupItem = props => {
    const activeClass = props.value == props.activeId ? "active" : "";
    return (
      <li className={"ui-dropdown-list-item " + activeClass}>
        <a href="#" onClick={(e)=>{props.handleItemChange(e,props.value);props.closeDropdown()}}>
          {props.name}
        </a>
      </li>
    );
};
  
const DropdownListPopup = props => {
    return (
        <ul className="ui-dropdown-list">
            {props.list.map((item, index) => (
                <DropdownPopupItem
                key={index}
                value={item.value}
                name={item.name}
                handleItemChange={props.handleItemChange}
                currentJobId={props.activeItem}
                closeDropdown={props.closeDropdown}
                activeId={props.activeId}
                />
            ))}
        </ul>
    );
};


class Dropdown extends Component {
    constructor(props) {
    super(props);
        this.state = {
            showDropdown: false,
            
        };
        this.handleShowDropdown = this.handleShowDropdown.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
    }

    componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('onTouchEnd', this.handleClickOutside);
    }
    
    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('onTouchEnd', this.handleClickOutside);
    }
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside = (event) =>{
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
          this.setState({showDropdown:false});
        }
    }

    handleShowDropdown = () => {
        this.setState({showDropdown:!this.state.showDropdown})
    }
    closeDropdown = () => {
        this.setState({showDropdown:false})
    }
    
    render() {
        const { className,list,placeholder, ...other } = this.props;
        //ConsoleLog("dropdown list",list)
        return (
            <div className={"ui-dropdown " + className} ref={this.setWrapperRef} onClick={this.props.activeItem !=="N/A"?()=>this.handleShowDropdown():''}>
                <div className="ui-dropdown_input">
                    <div className="ui-dropdown-value">
                        {(this.props.activeItem) ?
                            <span>{this.props.activeItem}</span>
                            : 
                            (placeholder) ? 
                                <span className="placeholder-text">{placeholder}</span> : null
                        }
                        {list.length>0?<img src={dropdown}/>:''}
                    </div>
                    {this.state.showDropdown?
                    <div className="ui-dropdown-popup">
                    <DropdownListPopup
                        list={list}
                        activeItem={this.props.activeItem}
                        handleItemChange ={this.props.handleItemChange}
                        closeDropdown={this.closeDropdown}
                        activeId={this.props.activeId}
                    />
                    </div>
                    :""}
                </div>
            </div>
        );
    }
}
  

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/UI/DropDown/Dropdown.js